import {
  GET_TAG_TYPES,
  FETCH_TAG_TYPE,
  ADD_TAG_TYPE,
  UPDATE_TAG_TYPE,
  DELETE_TAG_TYPE,
  CLEAR_TAG_TYPES,
  TAG_TYPES_PAGE,
  CLEAR_ALL,
  TAG_TYPES_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  tag_types: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function tagTypes(state = initialState, action) {
  switch (action.type) {
    case TAG_TYPES_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_TAG_TYPES:
      return {
        ...state,
        tag_types: action.payload,
        pending: false,
      };
    case TAG_TYPES_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_TAG_TYPE:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_TAG_TYPE:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_TAG_TYPE:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_TAG_TYPE:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_TAG_TYPES:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}